import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

import Login from "@/pages/Login.vue";

import Token from "@/pages/Token.vue";

// Admin pages
const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "@/pages/Dashboard.vue");
const Statistics = () =>
  import(/* webpackChunkName: "dashboard" */ "@/pages/Statistics.vue");
const Settings = () =>
  import(/* webpackChunkName: "dashboard" */ "@/pages/Settings.vue");

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/panel",
    children: [
      {
        path: "panel",
        name: "panel",
        component: Dashboard
      },
      {
        path: "stats",
        name: "stats",
        component: Statistics
      },
      {
        path: "settings",
        name: "settings",
        component: Settings
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/token/:token",
    name: "token",
    component: Token,
  },
  {
    path: '/index.html', //pwa fix for /index.html
    beforeEnter: (to, from, next) => {
      next('/')
    }
  },
  { path: "*", component: NotFound }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/


export default routes;
